import {
  AvailableProductTrialType,
  AvailableProductTrialTypesOrder,
  isMainProduct,
} from '../../types/AvailableProductTrialType';
import { InProductTrialCannotBeStartedReason } from '../../types/InProductTrialCannotBeStartedReason';
import { AvailableOperation } from '../../types/AvailableOperation';
import { ProductLandingPageBuyConfigDataProvider } from '../../types/ProductLandingPageBuyConfig';

export interface InProductTrialsAppViewData {
  availableInProductTrialsDetails: AvailableInProductTrialsDetails;
  buyProductCardDataProvider: ProductLandingPageBuyConfigDataProvider;
}

export interface AvailableInProductTrialsDetails {
  availableTrials: Array<AvailableInProductTrial>;
}

export interface AvailableInProductTrial {
  type: AvailableProductTrialType;
  isAddon: boolean;
  availableOperation: AvailableOperation;
  cannotBeStartedReason?: InProductTrialCannotBeStartedReason;
  cannotBeStartedUntil?: number;
  replacedKey?: string;
  canBuy?: boolean;
}

export namespace AvailableInProductTrialsDetails {
  const MAX_PROMOTED_PRODUCTS_SIZE = 2;

  export function getMainAndSecondaryInProductTrials(
    availableInProductTrialsDetails: AvailableInProductTrialsDetails
  ): {
    mainProducts: Array<AvailableInProductTrial>;
    secondaryProducts: Array<AvailableInProductTrial>;
  } {
    // get sorted trials
    const availableOrderedTrials = availableInProductTrialsDetails.availableTrials.sort(
      (productItem1, productItem2) => {
        return AvailableProductTrialTypesOrder[productItem1.type] - AvailableProductTrialTypesOrder[productItem2.type];
      }
    );

    // only first two main products are promoted
    const availableMainTrials = availableOrderedTrials
      .filter(license => isMainProduct[license.type])
      .slice(0, MAX_PROMOTED_PRODUCTS_SIZE);
    const availableSecondaryTrials = availableOrderedTrials.slice(
      availableMainTrials.length,
      availableOrderedTrials.length
    );

    return {
      mainProducts: availableMainTrials,
      secondaryProducts: availableSecondaryTrials,
    };
  }

  export function getAvailableInProductTrialForTrialTypeIfExists(
    type: AvailableProductTrialType,
    availableInProductTrialsDetails: AvailableInProductTrialsDetails
  ): AvailableInProductTrial | undefined {
    return availableInProductTrialsDetails.availableTrials.find(availableTrial => availableTrial.type === type);
  }
}
